<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-container">
        <div class="modal-header">
          <h3>{{ titulo }}</h3>
        </div>
        <div class="modal-body">
          <p>
            <strong style="color:red">ATENÇÃO:</strong> Haverá extrapolação do <strong style="text-transform:uppercase;">{{msg}}</strong> após a confirmação.
          </p>
         
          <p>
            Para continuar assim mesmo, informe uma
            <strong>JUSTIFICATIVA</strong> e sua
            <strong>SENHA</strong> nos campos abaixo, e clique em confirmar:
          </p>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Justificativa</label>
                <textarea required v-model="justificativa" class="form-control" rows="3"></textarea>
                <small style="color:red" v-show="justificativaInvalida">Informe uma justificativa</small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-md-offset-4">
              <div class="form-group" style="text-align: center;">
                <label style="font-size: 18px;">Digite sua senha</label>
                <input
                  style="text-align:center; font-size: 20px; padding: 20px;"
                  type="password"
                  v-model="senha"
                  class="form-control"
                />
                <small style="color:red" v-show="senhaInvalida">Senha inválida</small>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="text-right" style="float:right">
            <button class="btn btn-default" @click="$emit('close')">
              <i class="fa fa-close"></i> Fechar
            </button>
            <button class="btn btn-success" @click="confirma">
              <i class="fa fa-check"></i> Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios"; // Cliente para requisição http

export default {
  props: ["vagaSelecionada"],

  data: () => ({
    titulo: 'Extrapolação!',
    msg: '',
    senhaInvalida: false,
    justificativaInvalida: false,
    justificativa: "",
    senha: ""
  }),
  mounted() {
        let msg = "";
        if (this.vagaSelecionada.vagaPrestador == false) {
          if (msg != "") {
            msg += ", ";
          }

          msg += "atendimento disponível (vaga será criada)";
          this.titulo = "Extrapolação (Com criação de vaga)";
        }

        if (this.vagaSelecionada.cotaPrestador == false) {
          if (msg != "") {
            msg += ", ";
          }

          msg += "limite do prestador (cota será adicionada)";
        }

        if (this.cotaSolicitante == false) {
          if (msg != "") {
            msg += " e do ";
          }
          msg += "limite do solicitante (cota será adicionada)";
        }
        this.msg = msg;
  },
  methods: {
    confirma() {
      if (this.justificativa == '') {
          this.justificativaInvalida = true;
          return false;
      }
      axios
        .post(
          `${this.$store.state.serverURI}/api/confirmaSenha`,
          { senha: this.senha },
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          if (response.data) {
              this.$emit('confirma', this.justificativa);
          } else {
              this.senhaInvalida = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {},
  components: {}
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.modal-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 70%;
  margin: 40px auto 0;
  padding: 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #333;
}

.modal-body {
  margin: 10px 0;
}

.text-right {
  text-align: right;
}

.form-label {
  display: block;
  margin-bottom: 1em;
}

.form-label > .form-control {
  margin-top: 0.5em;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: 1px solid #ddd;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
  overflow-y: initial !important;
}

.modal-body {
  height: 400px;
  overflow-y: auto;
}
section {
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// modalExtrapolacao.vue?38be1e06